class Map {
  mapOptions = {
    zoom: 16,
    mapTypeControl: false,
    streetViewControl: false,
    draggable: false,
    scrollwheel: false,
    mapTypeId: "roadmap",
  };

  constructor($el) {
    this.$el = $el;

    if (!this.$el.length) return;

    this.apiKey = "AIzaSyCrv1vQp6EunMfsOiLHr2EcY97vlfn6MlI";
    this.location = {
      lat: 47.08363,
      lng: 8.624036,
    };

    this.map = null;
    this.marker = null;

    this.init();
  }

  init = async () => {
    await this.loadGoogleMaps();

    this.map = new google.maps.Map(this.$el[0], {
      ...this.mapOptions,
      center: this.location,
      styles: [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [{ color: "#444444" }],
        },
        {
          featureType: "landscape",
          elementType: "geometry.fill",
          stylers: [{ color: "#f2f2f2" }],
        },
        {
          featureType: "landscape.man_made",
          elementType: "geometry.fill",
          stylers: [{ color: "#bababa" }],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [{ saturation: -100 }, { lightness: 45 }],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [{ visibility: "simplified" }],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [{ color: "#d1d1d1" }, { visibility: "on" }],
        },
      ],
    });

    this.marker = new google.maps.Marker({
      position: this.location,
      map: this.map,
      draggable: false,
      clickable: false,
      icon: "upload/layout/pin_PIT_Betonpumpen.png",
    });
  };

  loadGoogleMaps = () => {
    return new Promise((resolve, reject) => {
      if (typeof google !== "undefined" && google.maps) {
        resolve();
        return;
      }

      if (document.querySelector("#google-maps-script")) {
        const existingScript = document.querySelector("#google-maps-script");

        existingScript.addEventListener("load", () => resolve());
        existingScript.addEventListener("error", () => reject());

        return;
      }

      const script = document.createElement("script");
      script.id = "google-maps-script";
      script.src = "https://maps.googleapis.com/maps/api/js?key=" + this.apiKey;
      script.async = true;
      script.defer = true;

      script.onload = () => resolve();
      script.onerror = () => reject();

      document.head.appendChild(script);
    });
  };
}

export default Map;
